import axios from 'axios'
var parseLinkHeader = require('parse-link-header')

/**
 * https://machinesaredigging.com/2014/04/27/binary-insert-how-to-keep-an-array-sorted-as-you-insert-data-in-it/
 * Example :
 * var a = [];
 * binaryInsert(value, a)
 * Don't insert duplicates
 * 
 * Spectral Scan Run
 * {
 *   key: <timestamp>
 *   value: <db_id>
 * }
 * 
 * Frequency
 * {
 *   key: <frequency>
 * }
 *
 */

function binaryInsert (value, array, startVal, endVal) {
	var length = array.length
	var start = typeof(startVal) != 'undefined' ? startVal : 0
	var end = typeof(endVal) != 'undefined' ? endVal : length - 1  //!! endVal could be 0 don't use || syntax
	var m = start + Math.floor((end - start)/2)
	if (length == 0){
		array.push(value)
		return;
	}
	if (value.key > array[end].key) {
		array.splice(end + 1, 0, value)
		return
	}
	if (value.key < array[start].key) {  //!!
		array.splice(start, 0, value)
		return
	}
	if (start >= end) {
		return
	}
	if (value.key < array[m].key) {
		binaryInsert(value, array, start, m - 1)
		return
	}
	if (value.key > array[m].key) {
		binaryInsert(value, array, m + 1, end)
		return
	}
	//we don't insert duplicates
}

const getGatewayStates = (context, payload = {page: 1}) => {
  axios
    .get(`gateway_states?page=${payload.page}`, {
      data: {},
    })
    .then(response => {
      context.commit('GATEWAY_LIST_VIEW_UPDATED', {
        headerLinks: parseLinkHeader(response.headers.link),
        total: response.headers.total,
        perPage: response.headers['per-page'],
        context: 'Gateways',
      })
      context.commit('GATEWAY_STATES_UPDATED', response.data)
    })
    .catch(error => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const getPromiseGatewayStates = (context, payload = {page: 1}) => {
  return new Promise ((resolve, reject) => {
    axios.get(`gateway_states?page=${payload.page}`, {
      data: {},
      params: payload.params
    }).then(response => {
      resolve (response)
    }, error => {
      reject (error)
    })
  })
}

const getGatewayRevisions = (context, payload = {page: 1}) => {
  axios
    .get(`gateways/${payload.id}/revisions?page=${payload.page}`, {
      data: {},
    })
    .then(response => {
      context.commit('GATEWAY_REVISIONS_VIEW_UPDATED', {
        headerLinks: parseLinkHeader(response.headers.link),
        total: response.headers.total,
        perPage: response.headers['per-page'],
        context: 'Gateway Revisions',
        collectionId: payload.id
      })
      context.commit('GATEWAY_REVISIONS_UPDATED', response.data)
    })
    .catch(error => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const getNetworkProfileRevisions = (context, payload = {page: 1}) => {
  axios
    .get(`network_profiles/${payload.id}/revisions?page=${payload.page}`, {
      data: {},
    })
    .then(response => {
      context.commit('NETWORK_PROFILE_REVISIONS_VIEW_UPDATED', {
        headerLinks: parseLinkHeader(response.headers.link),
        total: response.headers.total,
        perPage: response.headers['per-page'],
        context: 'Network Profile Revisions',
        collectionId: payload.id
      })
      context.commit('NETWORK_PROFILE_REVISIONS_UPDATED', response.data)
    })
    .catch(error => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const setGatewayState = (context, data) => {
  context.commit('GATEWAY_STATE_UPDATED', data)
}

const getGatewayState = (context, payload) => {
  axios
    .get(`gateway_states/${payload.id}`, {
      data: {},
    })
    .then(response => {
      context.commit('GATEWAY_STATE_UPDATED', response.data.data)
    })
    .catch(error => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const updateGatewayState = (context, payload) => {
  axios
    .put(`gateway_states/${payload.data.id}`, {
      data: payload.data,
    })
    .then(response => {
      context.commit('GATEWAY_STATE_UPDATED', response.data)
    })
    .catch(error => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const getGatewaySpectralScan = (context, payload) => {
  axios
  .get(`stats/gateway/${payload.id}/spectral/frequency_rssi_over_time`, {
    params: {
      // limit: payload.limit || 100,
      page: payload.page || 1,
      start_at: payload.start_at || '',
      end_at: payload.end_at || ''
    }
  })
  .then(response => {
    // Build sorted distinct time series list
    let timeArray = []
    if (response.data.included) {
      response.data.included.forEach((time_series) => {
        let obj = {
          key: time_series.attributes.time,
          value: time_series.id
        }
        binaryInsert(obj, timeArray)
      })
    }
    // Build sorted distinct frequency list
    let freqArray = []
    response.data.data.forEach((freq) => {
      let obj = {
        key: freq.attributes.frequency
      }
      binaryInsert(obj, freqArray)
    })
    // Build time series with injected frequencies
    let time_rows = []
    timeArray.forEach((time_series) => {
      let freq_rows = []
      response.data.data.forEach((freq) => {
        if (freq.relationships['spectral-scan-run'].data.id == time_series.value) {
          freq_rows.push(freq.attributes)
        }
      })
      time_rows.push({
        timestamp: time_series.key,
        id: time_series.value,
        rows: freq_rows
      })
    })

    context.commit('SPECTRAL_SCAN_VIEW_UPDATED', {
      headerLinks: parseLinkHeader(response.headers.link),
      total: response.headers.total,
      perPage: response.headers['per-page'],
      context: `Spectral ${payload.id}`,
    })
    context.commit('SPECTRAL_SCAN_UPDATED', {
      data: {
        rows: time_rows,
        freq_list: freqArray
      }
    })
  })
  .catch(error => {
    // eslint-disable-next-line
    console.error(error)
  })
}

const getLicenses = (context, payload) => {
  return new Promise ((resolve, reject) => {
    axios.get(`tokens`, {
      params: {
        gateway_ids: payload.id
      }
    }).then(response => {
      resolve (response)
    }, error => {
      reject (error)
    })
  })
}

const grab_token = (context, payload) => {
  return new Promise ((resolve, reject) => {
    axios.patch(`gateways/${payload.id}/grab_token`, {
      data: {
      },
    }).then(response => {
      resolve (response)
    }, error => {
      reject (error)
    })
  })
}

const release_token = (context, payload) => {
  return new Promise ((resolve, reject) => {
    axios.patch(`gateways/${payload.id}/release_token`, {
      data: {
      },
    }).then(response => {
      resolve (response)
    }, error => {
      reject (error)
    })
  })
}

export default {
  getGatewayStates,
  getPromiseGatewayStates,
  setGatewayState,
  getGatewayState,
  updateGatewayState,
  getGatewayRevisions,
  getNetworkProfileRevisions,
  getGatewaySpectralScan,
  getLicenses,
  grab_token,
  release_token
}



// WEBPACK FOOTER //
// ./src/modules/gatewayStates/store/actions.js